import isEmpty from 'validator/lib/isEmpty';
import { createField, updateField } from '../../actions';
import { EVENT_STEP_VALIDATE, VAT_VALIDATION_SETTINGS, COUNTRY_NETHERLANDS } from '../../helpers/consts';

export class VatNumberField {
    constructor(options) {
        this.validateMessages = {
            isEmpty: __('This is not a correct VAT number'),
            noHTML: __('No html allowed'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id );
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = false;

        const stateCountryField = this.state.formFields.find(field => field.id === 'companyCountry');
        const stateCountryFieldValue = stateCountryField ? stateCountryField.value : false;
        this.productCountry = this.state.product.language ? this.state.product.language.split('-')[1] : COUNTRY_NETHERLANDS;
        this.country = stateCountryFieldValue || this.productCountry;
        this.$el = this.createFieldElement();
        this.updateField(this.country);

        if (this.value !== '' || !this.required) {
            this.validate();
        }
    }

    createFieldElement () { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$fieldInput = document.createElement('input');
        this.$fieldMessage = document.createElement('span');

        this.$fieldInput.type = 'text';
        this.$fieldInput.id = this.id;
        this.$fieldInput.required = this.required;
        this.$fieldInput.value = this.value;
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', 'field--text')
        $fieldLabel.classList.add('field-label');
        this.$fieldInput.classList.add('field-input', 'form-control', 'field-input--text');
        this.$fieldMessage.classList.add('invalid-feedback');
        this.$fieldMessage.setAttribute('role', 'alert');

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$fieldInput);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldInput.addEventListener('blur', this.validate.bind(this));
        this.$fieldInput.addEventListener('input', () => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        return $field;
    }

    updateField(country) {
        const productLanguage = this.state.product.language ? this.state.product.language.split('-')[1] : COUNTRY_NETHERLANDS;
        this.country = country || productLanguage;
        this.$fieldInput.placeholder = (VAT_VALIDATION_SETTINGS[this.country]) ? VAT_VALIDATION_SETTINGS[this.country].placeholder : 'NL001234567B01';
        this.$fieldInput.required = VAT_VALIDATION_SETTINGS[this.country];
        this.required = VAT_VALIDATION_SETTINGS[this.country];
        this.$fieldInput.parentElement.classList.toggle('visually-hidden', !VAT_VALIDATION_SETTINGS[this.country]);

        if (this.productCountry !== 'BE' && this.country === COUNTRY_NETHERLANDS) {
            this.required = false;
            this.$fieldInput.required = false;
        }

        if (!VAT_VALIDATION_SETTINGS[this.country]) {
            this.setValue('');
        }

        this.validate();
    }

    setValue(value) {
        this.$fieldInput.value = value;
        this.validate(value === '');
    }

    validate() {
        this.$fieldInput.classList.remove('is-invalid');
        this.$fieldInput.classList.remove('is-valid');
        this.isValid = false;
        const vatRegex = VAT_VALIDATION_SETTINGS[this.country] ? VAT_VALIDATION_SETTINGS[this.country].regex : false;

        if(vatRegex !== false && vatRegex.test(this.$fieldInput.value)) {
            // Valid VAT number
            this.$fieldInput.classList.remove('is-invalid');
            this.$fieldInput.classList.add('is-valid');
            this.isValid = true;
        } else {
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.isEmpty;
            this.isValid = false;
        }

        if (isEmpty(this.$fieldInput.value)) {
            if (this.required) {
                this.$fieldInput.classList.add('is-invalid');
                this.$fieldInput.classList.remove('is-valid');
                this.isValid = false;
                this.$fieldMessage.innerHTML = this.validateMessages.isEmpty.replace(/%s/g, this.label);
            } else {
                this.$fieldInput.classList.remove('is-invalid');
                this.$fieldInput.classList.remove('is-valid');
                this.isValid = true;
            }
        }

        if (this.isValid) {
            this.store.dispatch(updateField(this.id, this.$fieldInput.value, this.isValid, this.label));
        }
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default VatNumberField;
